module.exports = "/_next/static/images/Pin_locked@2x-f91bcc13c4c2b4b0c52715c282bdf9e4.png";